import {
  httpsCallableWrapper,
  typedHttpsCallableWrapper,
  typedOnRequestWrapper
} from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export class APIIntegrationImPACT {
  /**
   * Check if the current user is currently in the ImPACT Pilot
   */
  public static isInPilot = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.pilot.isInPilot
  );

  /**
   * Join the ImPACT Pilot
   */
  public static joinPilot = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.pilot.join
  );

  public static leavePilot = httpsCallableWrapper<void, 'Ok'>(
    API_ROUTE_CONFIG.clinic.integration.impact.pilot.leave
  );

  public static addPatient = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.addPatient
  );

  public static generateFakeToken = httpsCallableWrapper<
    void,
    { token: string }
  >(API_ROUTE_CONFIG.clinic.integration.impact.token.generateSampleToken);
  public static decodeToken = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.token.decodeToken
  );

  public static isAssignedToPatientWithPassportId = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.isAssignedToPatientWithPassportId
  );

  /**
   * Check if an encrypted token is valid
   */
  public static isTokenValid = typedOnRequestWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.token.isValid
  );
}
